<template>
  <div class="w-3/4">
    <div>
      <m-alert type="alert-info" can-close="false">
        <h3 class="font-bold">New to Heffron IQ?</h3>
        <p class="text-sm leading-tight">
          If you are purchasing for a new Heffron IQ user,
          please invite them prior to selecting the course.
          Newly invited users will need to accept the invite
          before you can purchase on their behalf.
          <router-link
            to="/account/users"
            class="block mt-2 text-blue-800 font-semibold underline"
          >
            Invite a new user
          </router-link>
        </p>
      </m-alert>
    </div>
    <h3 class="mt-4 text-sm uppercase text-gray-700 font-bold">Select users for purchase</h3>
    <ul>
      <account-user-item
        v-for="user in users"
        :key="user.uuid"
        :user="user"
        @selected="updateSelectedUsers"
        :app='app'
      />
    </ul>
  </div>
</template>

<script>
import AccountUserItem from './account-user-item.vue';

export default {
  name: 'account-users',
  components: {
    AccountUserItem,
  },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    app: {
      type: String,
    },
  },
  data() {
    return {
      selectedUsers: [],
    };
  },
  methods: {
    updateSelectedUsers(val) {
      if (val.type === 'add') this.selectedUsers.push(val.user);
      if (val.type === 'remove') {
        this.selectedUsers = this.selectedUsers.filter(user => val.user.uuid !== user.uuid);
      }
      this.$emit('update', this.selectedUsers);
    },
  },
};
</script>
